import sharedConstants from "@lib/shared_constants";

import type { AllRouteEndpoints } from "../routeTypes";

export const productAlerts = "/product_alerts";
export const productAlertsId = "/product_alerts/:id";

export const productAlertsIdCacheKeys: AllRouteEndpoints[] = [productAlertsId, productAlerts];

/** `error_code` of the 422 the backend returns when the target already carries its maximum number of alerts. */
export const productAlertTargetLimitReachedErrorCode =
  sharedConstants.PRODUCT_ALERTS.ERROR_CODES.TARGET_ALERT_LIMIT_REACHED;
